export default "__VITE_ASSET__62a827a5__"